/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { ServizioMensaRicaricaReportRowDTO } from './servizio-mensa-ricarica-report-row-dto';


export interface PagedModelServizioMensaRicaricaReportRowDTO { 
    content?: Array<ServizioMensaRicaricaReportRowDTO>;
    page?: PageMetadata;
}

